import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { idConvocatorias } from "../../../../redux/actions/convocatoriaAction";
import { Convocatoria2 } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import "./cards.style.scss";
import moment from "moment";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import ImageNotFound from "../../../../assets/enmascarar-detail.png";
import { useConvocatoriaImage } from "../../../../hooks/useConvocatoriaImage";
import { fechaCierre } from '../../../../utils/horaCierre';

interface StateConvocatoria {
  convocatorias: Convocatoria2;
}

export const Cards: React.FC<StateConvocatoria> = (props: StateConvocatoria) => {
  const dispatch = useDispatch();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);
  const { dataImg, loading } = useConvocatoriaImage(props.convocatorias?.portada_url);

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(Array.isArray(data) ? data : (data?.data || []));
    } catch (error) {
      setLineasConvocatorias([]);
    }
  };

  const getFilterLineaConvocatoria = (idLineaConvocatoria: any) => {
    const valueFilter = LineasConvocatorias.filter((x: any) => String(x.id) === String(idLineaConvocatoria));
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    }
  };

  const calcularEstado = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    const inicio = props.convocatorias.fechas.filter((data: any) => data.clave === "Apertura")[0]?.valormin;
    const cierre = props.convocatorias.fechas.find((data: any) => data.clave === "Cierre");
    let formattedDate2 = "";
    if (cierre) {
      const valormax = fechaCierre(cierre.valormax);
      const year2 = valormax.getFullYear();
      const month2 = String(valormax.getMonth() + 1).padStart(2, "0");
      const day2 = String(valormax.getDate()).padStart(2, "0");
      const hours2 = String(valormax.getHours()).padStart(2, "0");
      const minutes2 = String(valormax.getMinutes()).padStart(2, "0");
      formattedDate2 = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`;
    }

    if (inicio && cierre) {
      if (formattedDate >= inicio && formattedDate <= formattedDate2) {
        return "Abierta";
      }
      if (formattedDate <= inicio) {
        return "En espera";
      }
      return "Cerrada";
    }
    return "Cerrada";
  };

  useEffect(() => {
    getLineasConvocatorias();
  }, []);

  const estado = calcularEstado();

  const fechaInicio = (() => {
    const fechas = props.convocatorias.fechas;
    if (!fechas || fechas.length === 0) return "--";
    const apertura = fechas.filter((d: any) => d.clave === "Apertura");
    return apertura.length > 0
      ? moment(apertura[0].valormin.substring(0, 10)).format("DD MMM / YYYY")
      : "--";
  })();

  const fechaFin = (() => {
    const fechas = props.convocatorias.fechas;
    if (!fechas || fechas.length === 0) return "--";
    const cierre = fechas.filter((d: any) => d.clave === "Cierre");
    return cierre.length > 0
      ? moment(cierre[0].valormin.substring(0, 10)).format("DD MMM / YYYY")
      : "--";
  })();

  const convAny = props.convocatorias as any;
  const nombreLinea = getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria) ||
    convAny?.nombre_linea ||
    convAny?.linea_nombre ||
    convAny?.lineas_convocatoria ||
    (typeof convAny?.linea === "string" ? convAny.linea : "") ||
    (props.convocatorias.nombre_convocatoria?.toLowerCase().includes("jurado") ? "Banco de Jurados" : "Estímulos y Fomento");

  const statusClass = estado === "Abierta"
    ? "status-abierta"
    : estado === "En espera"
      ? "status-espera"
      : "status-cerrada";

  return (
    <a
      href={`/estimuloscultura/verconvocatoria/${props.convocatorias.idconvocatorias}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.preventDefault();
        window.open(e.currentTarget.href, "_blank", "noopener,noreferrer");
        dispatch(idConvocatorias(props.convocatorias.idconvocatorias));
      }}
      className="modern-convocatoria-card-link"
    >
      <article className="modern-convocatoria-card">
        {/* Contenedor de la Imagen con pastilla de estado flotante */}
        <div className="card-cover-wrapper">
          <img
            alt={props.convocatorias.nombre_convocatoria}
            className="card-cover-img"
            src={dataImg ? dataImg : ImageNotFound}
            loading="lazy"
          />
          <div className="card-cover-gradient" />

          {/* Pastilla flotante de Estado con punto interactivo */}
          <span className={`card-status-pill ${statusClass}`}>
            <span className="status-dot" />
            {estado}
          </span>

          {/* Entidad en el borde inferior de la imagen */}
          {props.convocatorias.entidad && (
            <span className="card-entidad-chip" title={props.convocatorias.entidad}>
              {props.convocatorias.entidad}
            </span>
          )}
        </div>

        {/* Cuerpo informativo de la tarjeta */}
        <div className="card-content-body">
          <div className="card-header-info">
            {/* Nombre de la convocatoria más pequeño */}
            <span className="card-convocatoria-sub" title={props.convocatorias.nombre_convocatoria}>
              {props.convocatorias.nombre_convocatoria}
            </span>

            {/* Nombre de la línea debajo con negrilla */}
            <h3 className="card-linea-title card-title-text" title={nombreLinea}>
              {nombreLinea}
            </h3>
          </div>

          {/* Cronograma / Fechas estilo Timeline */}
          <div className="card-dates-timeline">
            <div className="date-item">
              <span className="date-label">Apertura</span>
              <span className="date-value">{fechaInicio}</span>
            </div>
            <span className="date-separator">→</span>
            <div className="date-item date-cierre">
              <span className="date-label">Cierre</span>
              <span className="date-value">{fechaFin}</span>
            </div>
          </div>

          {/* Metadatos en pastillas compactas */}
          <div className="card-metadata-pills">
            {/* Perfil */}
            {Array.isArray(props.convocatorias.tipo_participante) && props.convocatorias.tipo_participante.length > 0 && (
              <div className="meta-row">
                <span className="meta-tag-label">Perfil:</span>
                <div className="meta-tag-chips">
                  {props.convocatorias.tipo_participante.slice(0, 2).map((tp: any, idx: number) => (
                    <span key={idx} className="chip-pill" title={tp.text}>
                      {tp.text}
                    </span>
                  ))}
                  {props.convocatorias.tipo_participante.length > 2 && (
                    <span className="chip-pill">+{props.convocatorias.tipo_participante.length - 2}</span>
                  )}
                </div>
              </div>
            )}

            {/* Expresión / Área */}
            {Array.isArray(props.convocatorias.area) && props.convocatorias.area.length > 0 && (
              <div className="meta-row">
                <span className="meta-tag-label">Área:</span>
                <div className="meta-tag-chips">
                  {props.convocatorias.area.slice(0, 2).map((a: any, idx: number) => (
                    <span key={idx} className="chip-pill" title={a.text}>
                      {a.text}
                    </span>
                  ))}
                  {props.convocatorias.area.length > 2 && (
                    <span className="chip-pill">+{props.convocatorias.area.length - 2}</span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </article>
    </a>
  );
};
